import './ButtonWithIcon.css'

export interface IButtonParams {
    label: string;
    icon?: string;
    color: string;
    backgroundColor: string;
    onClick: () => void;
    testId?: string;
    disable?:boolean;
    fontSize?: string;
    border?: string
    
};
const ButtonWithIcon: React.FC<IButtonParams> = ({ label, icon, backgroundColor, border, color, testId, fontSize, onClick, disable = false }) => {
    return (
        <button 
              type='button'
              className='btn buttonWrapper' 
              data-testid={label} 
              id={testId}
              style={{ background: `${disable ? 'var(--primary-translucent)' : backgroundColor}`, color: `${disable ? 'var(--primary-color)' : color}`, borderColor: color, fontSize: fontSize, border: disable? '1px var(--color-primary-translucent)': border }} 
              onClick={() => onClick()}
              disabled ={disable}
              >
            {icon &&
                <span className='iconWrapper'>
                    <i className={`${icon}`}></i>
                </span>
            }
            {label}
        </button>
    );
};

export default ButtonWithIcon;